// extracted by mini-css-extract-plugin
module.exports = {"card-body":"style_card-body__Q7i6b"};